<script>
    // core components
    import CategoriaIvaView from "../../viewsERP/CategoriaIva.svelte";
</script>

<div class="flex flex-wrap mt-4">
    <div class="w-full mb-12 px-4">
        <CategoriaIvaView />
    </div>
</div>
